import React from 'react';
import { Avatar } from 'antd';
import { AvatarProps as AvatarCopyProps } from 'antd/lib/avatar';

export type AvatarProps = AvatarCopyProps;

const ProAvatar: React.FC<AvatarProps> = React.forwardRef<any, AvatarProps>(
  (props, ref) => {
    const { children, ...resProps } = props;
    return (
      <Avatar ref={ref} {...resProps}>
        {children}
      </Avatar>
    );
  },
);

export default ProAvatar;
